<template>
    <Toast />

    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-2">
                <h5>Client Logo Settings</h5>
                <div>
                    <Button label="Dashboard" icon="pi pi-th-large" class="p-button-sm p-mr-2" @click="goToDashboard" />
                    <Button label="Previous" icon="pi pi-chevron-left" class="p-button-sm" @click="goToPrevious" />

                </div>
            </div>
            <div v-if="loadingPage" style="height: 390px; position: relative">
                <div class="custom-modal-spinner-loader">
                    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                </div>
            </div>
            <div v-else class="card p-p-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-4">
                        <Card class="upload-card">
                            <template #title>
                                <h6>Client Logo </h6>
                            </template>

                            <template #content>
                                <div class="p-text-center">

                                    <img v-if="logoUrl" :src="logoUrl" alt="Client Logo" class="preview-img" />

                                    <i v-else class="pi pi-image upload-placeholder"></i>

                                    <FileUpload mode="basic" chooseLabel="Upload Logo" accept="image/*"
                                        :maxFileSize="5000000" auto class="p-mt-3" @select="handleClientLogoUpload" />
                                </div>
                            </template>
                        </Card>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <Card class="upload-card">
                            <template #title>
                                <h6>Banner Logo </h6>
                            </template>

                            <template #content>
                                <div class="p-text-center">

                                    <img v-if="bannerUrl" :src="bannerUrl" alt="Banner Image" class="preview-img" />

                                    <i v-else class="pi pi-images upload-placeholder"></i>

                                    <FileUpload mode="basic" chooseLabel="Upload Banner" accept="image/*"
                                        :maxFileSize="5000000" auto class="p-mt-3" @select="handleBannerUpload" />
                                </div>
                            </template>
                        </Card>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <Card class="upload-card">
                            <template #title>
                                <h6>Stamped Logo </h6>
                            </template>

                            <template #content>
                                <div class="p-text-center">

                                    <img v-if="stampedUrl" :src="stampedUrl" alt="Stamped Logo" class="preview-img" />

                                    <i v-else class="pi pi-bookmark upload-placeholder"></i>

                                    <FileUpload mode="basic" chooseLabel="Upload Stamp" accept="image/*"
                                        :maxFileSize="5000000" auto class="p-mt-3" @select="handleStampedUpload" />
                                </div>
                            </template>
                        </Card>
                    </div>
                </div>

                <div class="p-text-right p-mt-3">
                    <Button :label="saving ? 'Saving...' : 'Save'"
                        :icon="saving ? 'pi pi-spin pi-spinner' : 'pi pi-check'" @click="onSave" :disabled="saving" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from '@/service/ApiService'
import { useRoute } from 'vue-router'
import router from '@/router'

export default {
    data() {
        return {
            ApiService: new ApiService(),

            routeParam: '',
            loadingPage: true,
            saving: false,

            maa1: '',

            logoUrl: '',
            bannerUrl: '',
            stampedUrl: '',

            // storage path pieces (used to build full URL from filename)
            getStoragePath: '',
            bucket: '',
            client_logo: '',

            // Files
            maa103File: null,
            maa105File: null,
            maa107File: null,
        }
    },

    mounted() {
        const route = useRoute()
        this.routeParam = route.params.adminSubId
        // read storage path values similar to AdminInfoTab (if available)
        try {
            this.getStoragePath = JSON.parse(localStorage.getItem('storagePath')) || '';
        } catch (e) {
            this.getStoragePath = localStorage.getItem('storagePath') || '';
        }

        try {
            this.client_logo = JSON.parse(localStorage.getItem('CLIENT_LOGO')) || '';
        } catch (e) {
            this.client_logo = localStorage.getItem('CLIENT_LOGO') || '';
        }

        this.loadSettings()
    },

    methods: {
        async loadSettings() {
            this.loadingPage = true
            try {
                const res = await this.ApiService.getStaticLogoList({ clientId: this.routeParam })

                if (res?.status === 200 && res.data) {
                    const obj = res.data
                    this.bucket = JSON.parse(localStorage.masterBucketName);

                    // this.logoUrl = `${this.getStoragePath}${this.bucket}/${this.client_logo}/${obj.maa103}`;

                    this.logoUrl = obj.maa104;

                    // this.bannerUrl = `${this.getStoragePath}${this.bucket}/${this.client_logo}/${obj.maa105}`;
                    this.bannerUrl = obj.maa106;

                    // this.stampedUrl = `${this.getStoragePath}${this.bucket}/${this.client_logo}/${obj.maa107}`;
                    this.stampedUrl = obj.maa108;
                }

            } catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to load settings' })
            } finally {
                this.loadingPage = false
            }
        },

        handleClientLogoUpload(e) {
            if (e.files?.length) {
                this.maa103File = e.files[0]
                this.logoUrl = URL.createObjectURL(this.maa103File)
            }
        },

        handleBannerUpload(e) {
            if (e.files?.length) {
                this.maa105File = e.files[0]
                this.bannerUrl = URL.createObjectURL(this.maa105File)
            }
        },

        handleStampedUpload(e) {
            if (e.files?.length) {
                this.maa107File = e.files[0]
                this.stampedUrl = URL.createObjectURL(this.maa107File)
            }
        },

        async onSave() {
            if (!this.maa103File && !this.maa105File && !this.maa107File) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'No Changes',
                    detail: 'Please select at least one image'
                })
                return
            }

            this.saving = true
            const form = new FormData()
            form.append('maa1', this.routeParam)

            if (this.maa103File) form.append('maa103', this.maa103File)
            if (this.maa105File) form.append('maa105', this.maa105File)
            if (this.maa107File) form.append('maa107', this.maa107File)

            try {
                const res = await this.ApiService.UpdateStaticLogo(form)
                if (res?.status === 200) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Images updated successfully'
                    })
                    await this.loadSettings()
                    this.maa103File = this.maa105File = this.maa107File = null
                }
            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Save failed'
                })
            } finally {
                this.saving = false
            }
        },

        goToDashboard() {
            router.push({
                name: 'admindashboard',
                params: { adminId: this.routeParam }
            })
        },

        goToPrevious() {
            router.push({
                name: 'configSetting',
                params: { adminSubId: this.routeParam }
            })
        },
    }
}
</script>

<style scoped>
.card {
    border-radius: 8px;
}

.upload-card {
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.upload-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.preview-img {
    width: 120px;
    height: 120px;
    object-fit: contain;
    border-radius: 8px;
    border: 1px dashed #dcdcdc;
    padding: 8px;
}

.upload-placeholder {
    font-size: 64px;
    color: #c5c5c5;
    display: block;
    margin: 24px 0;
}
</style>
